import React, { useState, useEffect } from 'react';
import ForYouFeed from './ForYouFeed';
import FollowingFeed from './FollowingFeed';
import MetricsFeed from './MetricsFeed';


const Home = () => {
  const [activeTab, setActiveTab] = useState('forYou');
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    // Get user ID from localStorage or token
    const token = localStorage.getItem('token');
    if (token) {
      // Decode the JWT token to get user ID
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        setUserId(payload.id || payload.userId);
      } catch (error) {
        console.error('Error decoding token:', error);
        // Set a default user ID for testing
        setUserId('507f1f77bcf86cd799439011');
      }
    } else {
      // Set a default user ID for testing if no token
      setUserId('507f1f77bcf86cd799439011');
    }
  }, []);

  const tabs = [
    { id: 'forYou', label: 'For You', description: 'Mixed content feed' },
    { id: 'following', label: 'Following', description: 'Focused study content' },
    { id: 'metrics', label: 'Metrics', description: 'Your progress' }
  ];

  return (
    <div className="h-full">
      {/* Header with tabs */}
      <div className="sticky top-0 bg-white/80 backdrop-blur-sm border-b border-gray-200 z-10">
        <div className="flex">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`
                flex-1 px-4 py-4 text-center font-medium transition-colors relative
                ${activeTab === tab.id
                  ? 'text-blue-600'
                  : 'text-gray-500 hover:text-gray-700'
                }
              `}
            >
              <div>{tab.label}</div>
              <div className="text-xs mt-1 opacity-75">{tab.description}</div>
              {activeTab === tab.id && (
                <div className="absolute bottom-0 left-0 right-0 h-1 bg-blue-600 rounded-full"></div>
              )}
            </button>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      <div className="p-0">
        {activeTab === 'forYou' && <ForYouFeed userId={userId} />}
        {activeTab === 'following' && <FollowingFeed userId={userId} />}
        {activeTab === 'metrics' && userId && <MetricsFeed userId={userId} />}
      </div>
    </div>
  );
};



export default Home;